import { create } from 'zustand';

import { getReferralRewards } from '@/service/invite';
import type { IBringInfoResponse } from '@/service/invite';

interface TypeReferral {
  data: IBringInfoResponse;
  getRewardDetail: () => void;
}

const useReferral = create<TypeReferral>()((set, _get) => ({
  data: {
    claimAccountNum: 0,
    claimRewardNum: 0,
    unclaimRewardNum: 0,
    fullyRegisteredAccountNum: 0,
    activeAccountNum: 0
  },
  getRewardDetail: () => {
    getReferralRewards().then((res) => {
      if (res.data.data) {
        set({ data: res.data.data });
      }
    });
  }
}));

export default useReferral;
